const itemNav = (state) => state.nav.map((item) => `<li><a href="#${item.url}">${item.item}</a></li>`)

const nav = (state) => `
<nav>
    <ul>
        ${itemNav(state).join('')}
    </ul>
</nav>`

export default nav
